module.exports = __webpack_public_path__ + "static/damian-md-72cabdcc789942db9a175ab9547b069c.jpg";